import { Component } from "../base/Component";
import { DomEvent, DomMouseEvent } from "./DomEvent";
import { Event, EventListener } from "./Event";
import { KeyModifiers, ModifierKeys } from "../keyhandling/KeyModifiers";

export interface MouseListener extends EventListener<MouseEvent> {
}

export class MouseEvent extends Event<Component> implements ModifierKeys {
    constructor(target: Component, domEvent?: Event | DomEvent) {
        super(target, domEvent);
    }

    public get altKey(): boolean {
        return this.domEvent.altKey;
    }

    public get ctrlKey(): boolean {
        return this.domEvent.ctrlKey;
    }

    public get shiftKey(): boolean {
        return this.domEvent.shiftKey;
    }

    public get domEvent(): DomMouseEvent {
        return super.domEvent as DomMouseEvent;
    }

    public hasModifiers(modifiers: ModifierKeys) {
        return KeyModifiers.hasModifiers(this, modifiers);
    }
}
